<h3 class="mm-question-preview-explanation-title">{{'questionPreview.explanationTitle' | translate}}</h3>
<p *ngIf="showExplanationText" class="mm-explanation" [innerHTML]="explanation.text ?? '' | markdown"></p>
